import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';
import {
  getSectionMessageFieldSettingsConfig,
  sectionMessageFieldParseIntoSettingsFormModel,
  sectionMessageFieldUpdateFromSettingsFormModel,
  TUiAlertTypes,
} from '../custom-section-with-message.configuration';
import { fieldsBaseConfigurationFormModel } from '../shared.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class CustomSectionMessageWithLinkFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = {
      ...fieldsBaseConfigurationFormModel(),
      sectionMessageFieldContentConfig: {
        title: '',
        message: '',
        extraMessage: '',
        extraMessageAsHtml: false,
        messageType: TUiAlertTypes.WARNING,
        links: [],
      },
    };
    this.settingsFormlyForm = [...getSectionMessageFieldSettingsConfig()];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return sectionMessageFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return sectionMessageFieldUpdateFromSettingsFormModel(model, this.field);
  }

  protected override getValidationsConfig() {
    return undefined;
  }
}
